import { render, staticRenderFns } from "./Cliente.vue?vue&type=template&id=53e54c3e&"
import script from "./Cliente.vue?vue&type=script&lang=ts&"
export * from "./Cliente.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports